var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.$style.step},[_c(_vm.icon,{tag:"component",class:_vm.$style.icon}),_c('div',{class:_vm.$style.stepText},[_c('h4',[_vm._v("Step "+_vm._s(_vm.step)+":")]),_vm._t("default"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }